import React from 'react';

const FooterInfo = {
    phone: {
        chinese: '咨询电话：0757-86321467',
        english: 'Tel：0757-86321467'
    },
    email: {
        chinese: '邮箱地址：pms01@pms.com.cn',
        english: 'Email：pms01@pms.com.cn'
    },
    address: [
        // {
        //     chinese: '广州办公地址：广州市天河区潭村路348号604房',
        //     english: 'Guangzhou Office Address: Room 604, No. 348, Tancun Road, Tianhe District, Guangzhou',
        // },
        {
            chinese: '佛山办公地址：佛山市南海区海五路28号富力国际金融中心A区2栋9层',
            english: 'Foshan Office: 9th Floor, Building 2, Area A, R&F International Financial Center, No. 28 Haiwu Road, Nanhai District, Foshan City',
        }, {
            chinese: '处理中心地址：佛山市南海区丹灶镇丹横路大涡村2号PMS跨境电商产业园',
            english: 'Warehouse: PMS Cross-border Electronic Commerce Industrial Park, No. 2, Dawa Village, Danheng Road, Danzao Town, Nanhai District, Foshan City，Guangdong Province, China',
        }
    ],
    // introduce:{
    //     chinese:'派敏斯速递业务范围：邮政代办业务;道路货物运输代理;运输货物打包服务;航空运输货物打包服务;打包、装卸、运输全套服务代理;其他仓储业（不含原油、成品油仓储、燃气仓储、危险品仓储）;仓储代理服务;商品批发贸易（许可审批类商品除外）;商品零售贸易（许可审批类商品除外）; (依法须经批准的项目，经相关部门批准后方可开展经营活动)',
    //     english:'PMS Express business area: \nPostal agency business, Road transport agent, Goods wrapped service, Air wrapped service, Wrapped and loading and removed full-service, Other warehousing service (Except for Crude oil, refined oil storage, gas storage, dangerous goods );Warehousing agent service; Commodity wholesale trade (Except for approval of approved goods); Commodity retail trade(Except for approval of approved goods); The program must be approved by the law and relevant business activities must approved by relevant departments.'
    // },
    company: {
        chinese: '广州派敏斯速递有限公司',
        english: 'Guangzhou PMS Express Co.ltd '
    },
    recordMsg: {
        msg: '粤ICP备17149640号-1',
        href: 'http://www.beian.miit.gov.cn'
    }
}
export default class FooterContainer extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { language } = this.props;
        return (
            <div className="pms-footer">
                <div className="pms-footer-container">
                    <div className="pms-footer-logo">
                        <img src={require('../assets/image/footer-logo.png')} alt="" />
                    </div>
                    <div className="pms-footer-info">
                        <div className="clear">
                            <div className="col-xs-4">
                                <p><i className="footer-icon"><img src={require('../assets/image/phone.png')}
                                    alt="" /></i>
                                    {FooterInfo.phone[language]}
                                </p>
                                <p>
                                    <i className="footer-icon"><img src={require('../assets/image/email.png')} alt="" /></i>
                                    {FooterInfo.email[language]}
                                </p>
                            </div>
                            <div className="col-xs-6">
                                {
                                    FooterInfo.address.map((addr, index) =>
                                        <p key={index}><i className="footer-icon"><img
                                            src={require('../assets/image/address.png')} alt="" /></i>
                                            {addr[language]}</p>)
                                }
                            </div>
                            <div className="qr-code-container">
                                <img src={require('../assets/image/qrCode.jpg')} alt="" />
                            </div>
                        </div>
                        {/*<div className="pms-introduce">*/}
                        {/*{FooterInfo.introduce[language]}*/}
                        {/*</div>*/}
                        <div className="pms-message">
                            {FooterInfo.company[language]}&nbsp;
                            <a href={FooterInfo.recordMsg.href} target="_blank" className="pms-footer-text">{FooterInfo.recordMsg.msg}</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./public/components/footer.js